import { defineMessages } from 'react-intl';

const messages = defineMessages({
    brand: {
        id: 'app.brand',
        defaultMessage: 'app',
        description: 'Brand name displayed in header',
    },
    about: {
        id: 'app.about',
        defaultMessage: 'About',
        description: 'About Nav link',
    },
    login: {
        id: 'app.login',
        defaultMessage: 'Login',
        description: 'Login Nav link',
    },
    signup: {
        id: 'app.signup',
        defaultMessage: 'Sign up',
        description: 'Sign up Nav link',
    },
    contact: {
        id: 'app.contact',
        defaultMessage: 'Contact',
        description: 'Contact Nav link',
    },
    bannerTitle: {
        id: 'app.bannerTitle',
        defaultMessage: 'React',
        description: 'Title in page header',
    },
    logo: {
        id: 'app.logo',
        defaultMessage: 'Logo',
        description: 'Logo'
    },
    siteSettings: {
        id: 'app.siteSettings',
        defaultMessage: 'Site settings',
        description: 'Site Settings'
    },
    HomeSiteSettings: {
        id: 'app.HomeSiteSettings',
        defaultMessage: 'Homepage settings',
        description: 'HomeSiteSettings'
    },
    driverRatings: {
        id: 'app.driverRatings',
        defaultMessage: 'Driver ratings',
        description: 'Driver Ratings'
    },
    messageRequired: {
        id: 'app.messageRequired',
        defaultMessage: 'Message is required',
        description: 'Message is required'
    },
    messageLength: {
        id: 'app.messageLength',
        defaultMessage: 'Message must be 200 characters or less',
        description: 'Message must be 200 characters or less'
    },
    metaKeyword: {
        id: 'app.metaKeyword',
        defaultMessage: 'Keyword must be 255 characters or less',
        description: 'Keyword must be 255 characters or less'
    },
    metaTitle: {
        id: 'app.metaTitle',
        defaultMessage: 'Meta title',
        description: 'Meta Title'
    },
    metaDescriptionText: {
        id: 'app.metaDescriptionText',
        defaultMessage: 'Meta description',
        description: 'Meta Description'
    },
    metaDescription: {
        id: 'app.metaDescription',
        defaultMessage: 'Description must be 255 characters or less',
        description: 'Description must be 255 characters or less'
    },
    pageTitle: {
        id: 'app.pageTitle',
        defaultMessage: 'Page title',
        description: 'Page Title'
    },
    pageUrl: {
        id: 'app.pageUrl',
        defaultMessage: 'Page URL',
        description: 'Page URL'
    },
    invalidUrl: {
        id: 'app.invalidUrl',
        defaultMessage: 'Invalid page URL',
        description: 'Invalid Page URL'
    },
    footerCategory: {
        id: 'app.footerCategory',
        defaultMessage: 'Footer category',
        description: 'Footer Category'
    },
    ratings: {
        id: 'app.ratings',
        defaultMessage: 'Ratings',
        description: 'Ratings'
    },
    reasonRequired: {
        id: 'app.reasonRequired',
        defaultMessage: 'Reason is required',
        description: 'Reason is required'
    },
    exceedLimit100: {
        id: 'app.exceedLimit100',
        defaultMessage: 'Please dont exceed 100 words',
        description: 'Please dont exceed 100 words'
    },
    exceedLimit: {
        id: 'app.exceedLimit',
        defaultMessage: 'The number of characters exceeded its specific limit',
        description: 'The number of characters exceeded its specific limit'
    },
    comments: {
        id: 'app.comments',
        defaultMessage: 'Comments',
        description: 'Comments'
    },
    cancellationReasons: {
        id: 'app.cancellationReasons',
        defaultMessage: 'Cancellation reasons',
        description: 'Cancellation Reasons'
    },
    cancelReason: {
        id: 'app.cancelReason',
        defaultMessage: 'Cancel reason',
        description: 'Cancel Reason'
    },
    cancelledBy: {
        id: 'app.cancelledBy',
        defaultMessage: 'Cancelled by',
        description: 'Cancelled By'
    },
    tripDate: {
        id: 'app.tripDate',
        defaultMessage: 'Trip Date',
        description: 'Trip Date'
    },
    changePassword: {
        id: 'app.changePassword',
        defaultMessage: 'Change password',
        description: 'Change Password'
    },
    addCancelReason: {
        id: 'app.addCancelReason',
        defaultMessage: 'Add cancel reason',
        description: 'Add Cancel Reason'
    },
    editCancelReason: {
        id: 'app.editCancelReason',
        defaultMessage: 'Edit cancel reason',
        description: 'Edit Cancel Reason'
    },
    reason: {
        id: 'app.reason',
        defaultMessage: 'Reason',
        description: 'Reason'
    },
    manageNotifications: {
        id: 'app.manageNotifications',
        defaultMessage: 'Manage notifications',
        description: 'Manage Notifications'
    },
    bannerDesc: {
        id: 'app.bannerDesc',
        defaultMessage: 'Complex web apps made easy',
        description: 'Description in header',
    },
    recommand: {
        id: 'app.recommand',
        defaultMessage: 'Recommand',
        description: 'recommand',
    },
    sliderContent: {
        id: 'app.sliderContent',
        defaultMessage: 'Luxury',
        description: 'Luxury',
    },
    heading: {
        id: 'app.heading',
        defaultMessage: 'Heading',
        description: 'heading',
    },
    dummyText: {
        id: 'app.dummyText',
        defaultMessage: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
        description: 'dummyText',
    },
    rentallContent: {
        id: 'app.rentallContent',
        defaultMessage: 'app',
        description: 'app',
    },
    aboutFooter: {
        id: 'app.aboutFooter',
        defaultMessage: 'About Us',
        description: 'AboutFooter',
    },
    contactUs: {
        id: 'app.contactUs',
        defaultMessage: 'Contact Us',
        description: 'contact',
    },
    Trust: {
        id: 'app.Trust',
        defaultMessage: 'Trust & Safety',
        description: 'Trust',
    },
    Travel: {
        id: 'app.Travel',
        defaultMessage: 'Travel Credit',
        description: 'Trust',
    },
    Discover: {
        id: 'app.Discover',
        defaultMessage: 'Discover',
        description: 'Discover',
    },
    Hosting: {
        id: 'app.Hosting',
        defaultMessage: 'Hosting',
        description: 'Hosting',
    },
    Becomeahost: {
        id: 'app.Becomeahost',
        defaultMessage: 'Become a host',
        description: 'Becomeahost',
    },
    Terms: {
        id: 'app.Terms',
        defaultMessage: 'Terms & Privacy',
        description: 'Terms',
    },
    adminpanel: {
        id: 'app.adminpanel',
        defaultMessage: 'Admin panel',
        description: 'admin panel',
    },
    dashboard: {
        id: 'app.dashboard',
        defaultMessage: 'Dashboard',
        description: 'dashboard',
    },
    settings: {
        id: 'app.settings',
        defaultMessage: 'Settings',
        description: 'settings',
    },
    users: {
        id: 'app.users',
        defaultMessage: 'Users',
        description: 'users',
    },
    formssidebar: {
        id: 'app.formssidebar',
        defaultMessage: 'Forms',
        description: 'formssidebar',
    },
    email: {
        id: 'app.emailaddress',
        defaultMessage: 'Email address',
        description: 'emailaddress',
    },
    emailaddress: {
        id: 'app.emailaddress',
        defaultMessage: 'Email address',
        description: 'emailaddress',
    },
    password: {
        id: 'app.password',
        defaultMessage: 'Password',
        description: 'password',
    },
    select: {
        id: 'app.select',
        defaultMessage: 'Select',
        description: 'select',
    },
    textarea: {
        id: 'app.textarea',
        defaultMessage: 'Text area',
        description: 'textarea',
    },
    firstName: {
        id: 'app.firstName',
        defaultMessage: 'First name',
        description: 'firstName',
    },
    lastName: {
        id: 'app.lastName',
        defaultMessage: 'Last name',
        description: 'lastName',
    },
    phoneNumber: {
        id: 'app.phoneNumber',
        defaultMessage: 'Phone number',
        description: 'phoneNumber',
    },
    profilePicture: {
        id: 'app.profilePicture',
        defaultMessage: 'Profile picture',
        description: 'profilePicture',
    },
    licenceFrontImage: {
        id: 'app.licenceFrontImage',
        defaultMessage: 'Licence front image',
        description: 'licenceFrontImage'
    },
    licenceBackImage: {
        id: 'app.licenceBackImage',
        defaultMessage: 'Licence back image',
        description: 'licenceBackImage'
    },
    rcImage: {
        id: 'app.rcImage',
        defaultMessage: 'RC book image',
        description: 'rcImage'
    },
    insuranceImage: {
        id: 'app.insuranceImage',
        defaultMessage: 'Insurance image',
        description: 'insuranceImage'
    },
    required: {
        id: 'app.required',
        defaultMessage: '*Required',
        description: 'required error message',
    },
    emailRequired: {
        id: 'app.emailRequired',
        defaultMessage: 'Email is required',
        description: 'Email is required',
    },
    emailInvalid: {
        id: 'app.emailInValid',
        defaultMessage: 'Invalid email address',
        description: 'Invalid Email Address',
    },
    emailNotExists: {
        id: 'app.emailNotExists',
        defaultMessage: 'No account exists for this email. Make sure it\'s typed in correctly, or “sign up” instead',
        description: 'Email Address is not exist',
    },
    passwordRequired: {
        id: 'app.passwordRequired',
        defaultMessage: 'Password is required',
        description: 'Password is required',
    },
    passwordInvalid: {
        id: 'app.passwordInValid',
        defaultMessage: 'Your password must be at least 8 characters. Please try again',
        description: 'Invalid Password',
    },
    passwordWrong: {
        id: 'app.passwordWrong',
        defaultMessage: 'Wrong password. Please try again',
        description: 'Wrong Password',
    },
    somethingWentWrong: {
        id: 'app.somethingWentWrong',
        defaultMessage: 'Sorry, something went wrong. Please try again',
        description: 'Wrong went wrong',
    },
    loggedIn: {
        id: 'app.loggedIn',
        defaultMessage: 'You are already logged in!',
        description: 'You are already Logged-in',
    },
    submitButton: {
        id: 'app.submitButton',
        defaultMessage: 'Submit',
        description: 'Submit',
    },
    cancelButton: {
        id: 'app.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Cancel',
    },
    table: {
        id: 'app.table',
        defaultMessage: 'Table',
        description: 'Table',
    },
    form: {
        id: 'app.form',
        defaultMessage: 'Form',
        description: 'form',
    },
    menuOne: {
        id: 'app.menuOne',
        defaultMessage: 'MenuOne',
        description: 'form',
    },
    menuTwo: {
        id: 'app.menuTwo',
        defaultMessage: 'MenuTwo',
        description: 'MenuTwo',
    },
    menuFour: {
        id: 'app.menuFour',
        defaultMessage: 'MenuFour',
        description: 'menuFour',
    },
    subMenuOne: {
        id: 'app.subMenuOne',
        defaultMessage: 'subMenuOne',
        description: 'subMenuOne',
    },
    subMenuTwo: {
        id: 'app.subMenuTwo',
        defaultMessage: 'subMenuTwo',
        description: 'subMenuTwo',
    },
    subMenuThree: {
        id: 'app.subMenuThree',
        defaultMessage: 'subMenuThree',
        description: 'subMenuThree',
    },
    siteAdmin: {
        id: 'app.siteAdmin',
        defaultMessage: 'Welcome Admin!',
        description: 'siteAdmin',
    },
    ridersMenu: {
        id: 'app.ridersMenu',
        defaultMessage: 'Manage riders',
        description: 'ridersMenu',
    },
    driverMenu: {
        id: 'app.driverMenu',
        defaultMessage: 'Manage drivers',
        description: 'driverMenu',
    },
    vehiclesMenu: {
        id: 'app.vehiclesMenu',
        defaultMessage: 'Manage vehicles',
        description: 'vehiclesMenu',
    },
    categoryMenu: {
        id: 'app.categoryMenu',
        defaultMessage: 'Manage categories',
        description: 'categoryMenu',
    },
    categorieslist: {
        id: 'app.categorieslist',
        defaultMessage: 'Categories',
        description: 'categoryMenu',
    },
    bookingsMenu: {
        id: 'app.bookingsMenu',
        defaultMessage: 'Manage bookings',
        description: 'bookingsMenu',
    },
    Wooberly: {
        id: 'app.Wooberly',
        defaultMessage: 'Wooberly',
        description: 'Wooberly',
    },
    city: {
        id: 'app.city',
        defaultMessage: 'Lorem Ipsum is simply dummy text',
        description: 'city',
    },
    categoryTitle: {
        id: 'app.categoryTitle',
        defaultMessage: 'Category title',
        description: 'Category Title',
    },
    categoryContent: {
        id: 'app.categoryContent',
        defaultMessage: 'Category content',
        description: 'Category Content',
    },
    viewCity: {
        id: 'app.viewCity',
        defaultMessage: 'View city',
        description: 'view City',
    },
    Safety: {
        id: 'app.Safety',
        defaultMessage: 'Safety',
        description: 'Safety',
    },
    safetyContent: {
        id: 'app.safetyContent',
        defaultMessage: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
        description: 'Safety',
    },
    safetyButton: {
        id: 'app.safetyButton',
        defaultMessage: 'View all safety features',
        description: 'safetyButton',
    },
    signupDrive: {
        id: 'app.signupDrive',
        defaultMessage: 'Sign up to drive',
        description: 'Sign up to drive',
    },
    signupRide: {
        id: 'app.signupRide',
        defaultMessage: 'Sign up to ride',
        description: 'Sign up to ride',
    },
    profileId: {
        id: 'app.profileId',
        defaultMessage: 'Profile ID',
        description: 'Profile Id for user'
    },
    country: {
        id: 'app.country',
        defaultMessage: 'Country',
        description: 'Country Name'
    },
    createdAt: {
        id: 'app.createdAt',
        defaultMessage: 'Account created on',
        description: 'Created date'
    },
    action: {
        id: 'app.action',
        defaultMessage: 'Action',
        description: 'Action'
    },
    vehicleType: {
        id: 'app.vehicleType',
        defaultMessage: 'Vehicle type',
        description: 'Vehicle Type'
    },
    minBasePrice: {
        id: 'app.minBasePrice',
        defaultMessage: 'Minimum base price',
        description: 'Minimum base price amount'
    },
    riderCommission: {
        id: 'app.riderCommission',
        defaultMessage: 'Rider commission(%)',
        description: 'Rider Commission Percentage'
    },
    driverCommission: {
        id: 'app.driverCommission',
        defaultMessage: 'Driver commission(%)',
        description: 'Driver Commission Percentage'
    },
    vehicleName: {
        id: 'app.vehicleName',
        defaultMessage: 'Vehicle name',
        description: 'Vehicle Name'
    },
    vehicleNumber: {
        id: 'app.vehicleNumber',
        defaultMessage: 'Plate Number',
        description: 'Plate Number'
    },
    status: {
        id: 'app.status',
        defaultMessage: 'Status',
        description: 'Status Active/Inactive'
    },
    editAction: {
        id: 'app.editAction',
        defaultMessage: 'Edit',
        description: 'Edit action name'
    },
    deleteAction: {
        id: 'app.deleteAction',
        defaultMessage: 'Delete',
        description: 'Delete action name'
    },
    vehicleOwnerName: {
        id: 'app.vehicleOwnerName',
        defaultMessage: 'Vehicle owner name',
        description: 'Vehicle Owner Name'
    },
    vehicleOwnerEmail: {
        id: 'app.vehicleOwnerEmail',
        defaultMessage: 'Vehicle owner email',
        description: 'Vehicle Owner Email'
    },
    minutePrice: {
        id: 'app.minutePrice',
        defaultMessage: 'Minute price',
        description: 'Minute Price'
    },
    unitPrice: {
        id: 'app.unitPrice',
        defaultMessage: 'Unit price',
        description: 'Unit Price'
    },
    riderFeeType: {
        id: 'app.riderFeeType',
        defaultMessage: 'Rider fee type',
        description: 'Rider Fee Type'
    },
    fixedFeeType: {
        id: 'app.fixed',
        defaultMessage: 'Fixed',
        description: 'Fixed Fee Type'
    },
    percentageFeeType: {
        id: 'app.percentageFeeType',
        defaultMessage: 'Percentage',
        description: 'Percentage Fee Type'
    },
    driverFeeType: {
        id: 'app.driverFeeType',
        defaultMessage: 'Driver fee type',
        description: 'Driver Fee Type'
    },
    totalFare: {
        id: 'app.totalFare',
        defaultMessage: 'Total fare',
        description: 'Total Fare'
    },
    promoCodeId: {
        id: 'app.promoCodeId',
        defaultMessage: 'Promo code',
        description: 'Promo Code'
    },
    isSpecialTrip: {
        id: 'app.isSpecialTrip',
        defaultMessage: 'Special trip',
        description: 'Special Trip'
    },
    specialTripPrice: {
        id: 'app.specialTripPrice',
        defaultMessage: 'Rider discount amount',
        description: 'discount text'
    },
    riderPayableAmount: {
        id: 'app.riderPayableAmount',
        defaultMessage: 'Rider payable amount',
        description: 'Special Trip Total Fare'
    },
    tripStatus: {
        id: 'app.tripStatus',
        defaultMessage: 'Trip status',
        description: 'Trip Status'
    },
    riderName: {
        id: 'app.riderName',
        defaultMessage: 'Rider name',
        description: 'Rider Name'
    },
    driverName: {
        id: 'app.driverName',
        defaultMessage: 'Driver name',
        description: 'Driver Name'
    },
    riderEmail: {
        id: 'app.riderEmail',
        defaultMessage: 'Rider email',
        description: 'Rider Email'
    },
    driverEmail: {
        id: 'app.driverEmail',
        defaultMessage: 'Driver email',
        description: 'Driver Email'
    },
    pickUpLocation: {
        id: 'app.pickupLocation',
        defaultMessage: 'PickUp location',
        description: 'PickUp Location'
    },
    dropLocation: {
        id: 'app.dropLocation',
        defaultMessage: 'Drop location',
        description: 'Drop Location'
    },
    bookingId: {
        id: 'app.bookingId',
        defaultMessage: 'Booking ID',
        description: 'Booking ID'
    },
    category: {
        id: 'app.category',
        defaultMessage: 'Category',
        description: 'Category'
    },
    totalRideDistance: {
        id: 'app.totalRideDistance',
        defaultMessage: 'Total rider distance',
        description: 'Total Rider Distance'
    },
    totalDuration: {
        id: 'app.totalDuration',
        defaultMessage: 'Total duration',
        description: 'Total Duration'
    },
    vehicleId: {
        id: 'app.vehicleId',
        defaultMessage: 'Vehicle ID',
        description: 'Vehicle ID'
    },
    categoryId: {
        id: 'app.categoryId',
        defaultMessage: 'Category ID',
        description: 'Category ID'
    },
    view: {
        id: 'app.view',
        defaultMessage: 'View',
        description: 'View Details Link'
    },
    details: {
        id: 'app.details',
        defaultMessage: 'Details',
        description: 'Details'
    },
    riderServiceFee: {
        id: 'app.riderServiceFee',
        defaultMessage: 'Rider service fee',
        description: 'Rider Service Fee'
    },
    driverServiceFee: {
        id: 'app.driverServiceFee',
        defaultMessage: 'Driver service fee',
        description: 'Driver Service Fee'
    },
    riderTotalFare: {
        id: 'app.riderTotalFare',
        defaultMessage: 'Rider total fare',
        description: 'Rider Total Fare'
    },
    driverTotalFare: {
        id: 'app.driverTotalFare',
        defaultMessage: 'Driver total fare',
        description: 'Driver Total Fare'
    },
    tripStart: {
        id: 'app.tripStart',
        defaultMessage: 'Trip start',
        description: 'Trip Start'
    },
    tripEnd: {
        id: 'app.tripEnd',
        defaultMessage: 'Trip end',
        description: 'Trip End'
    },
    categoryName: {
        id: 'app.categoryName',
        defaultMessage: 'Category name',
        description: 'Category Name'
    },
    minutes: {
        id: 'app.minutes',
        defaultMessage: 'minutes',
        description: 'minutes'
    },
    update: {
        id: 'app.update',
        defaultMessage: 'Update',
        description: 'Update'
    },
    userStatus: {
        id: 'app.userStatus',
        defaultMessage: 'User status',
        description: 'User Status Active/Inactive'
    },
    active: {
        id: 'app.active',
        defaultMessage: 'Active',
        description: 'Active Status'
    },
    inactive: {
        id: 'app.inactive',
        defaultMessage: 'Inactive',
        description: 'Inactive Status'
    },
    pending: {
        id: 'app.pending',
        defaultMessage: 'Pending',
        description: 'Pending Status'
    },
    banStatus: {
        id: 'app.banStatus',
        defaultMessage: 'Ban status',
        description: 'Ban Status Permit/Ban'
    },
    permit: {
        id: 'app.permit',
        defaultMessage: 'Permit',
        description: 'Permit Status'
    },
    ban: {
        id: 'app.ban',
        defaultMessage: 'Ban',
        description: 'Ban Status'
    },
    phoneDialCode: {
        id: 'app.phoneDialCode',
        defaultMessage: 'Country code',
        description: 'Phone Dial Code'
    },
    dropzoneUpload: {
        id: "app.dropzoneUpload",
        defaultMessage: "Upload a file from your computer",
        description: "Dropzone upload info"
    },
    dropzoneUploadError: {
        id: "app.dropzoneUploadError",
        defaultMessage: "Remove the existing image and try upload again",
        description: "Dropzone upload error message"
    },
    riderFeeValue: {
        id: 'app.riderFeeValue',
        defaultMessage: 'Rider commission',
        description: 'Rider Fee Value'
    },
    driverFeeValue: {
        id: 'app.driverFeeValue',
        defaultMessage: 'Driver commission',
        description: 'Driver Fee Value'
    },
    addCategory: {
        id: 'app.addCategory',
        defaultMessage: 'Add Category',
        description: 'Add category form header'
    },
    editRider: {
        id: 'app.editRider',
        defaultMessage: 'Edit Rider',
        description: 'Edit rider form header'
    },
    editDriver: {
        id: 'app.editDriver',
        defaultMessage: 'Edit Driver',
        description: 'Edit driver form header'
    },
    editCategory: {
        id: 'app.editCategory',
        defaultMessage: 'Edit category',
        description: 'Edit category form header'
    },
    editVehicle: {
        id: 'app.editVehicle',
        defaultMessage: 'Edit vehicle',
        description: 'Edit vehicle form header'
    },
    goBack: {
        id: 'app.goBack',
        defaultMessage: 'Go back',
        description: 'Go Back Button Text'
    },
    capacity: {
        id: 'app.capacity',
        defaultMessage: 'Capacity',
        description: 'Capacity'
    },
    floatError: {
        id: 'app.floatError',
        defaultMessage: 'This entry can only contain numbers (for all fields)',
        description: 'Numeric Error Response'
    },
    numericValue: {
        id: 'app.numericValue',
        defaultMessage: 'Numeric value required',
        description: 'Numeric value required'
    },
    validUrl: {
        id: 'app.validUrl',
        defaultMessage: 'Valid URL required',
        description: 'Valid URL required'
    },
    intError: {
        id: 'app.intError',
        defaultMessage: 'It should be a decimal value',
        description: 'Integer Error Response'
    },
    percentError: {
        id: 'app.percentError',
        defaultMessage: 'Choose percentage value between 1 to 99',
        description: 'Choose percentage value between 1 to 99'
    },
    phoneError: {
        id: 'app.numberError',
        defaultMessage: 'Invalid phone number',
        description: 'Invalid Phone Number'
    },
    countryCodeError: {
        id: 'app.countryCodeError',
        defaultMessage: 'Invalid country code',
        description: 'Invalid Country Code'
    },
    vehicleNumberError: {
        id: 'app.vehicleNumberError',
        defaultMessage: 'Invalid vehicle number',
        description: 'Invalid Vehicle Number'
    },
    availableSeats: {
        id: 'app.availableSeats',
        defaultMessage: 'Available seats',
        description: 'Available Seats'
    },
    currency: {
        id: 'app.currency',
        defaultMessage: 'Currency',
        description: 'Currency Type'
    },
    invalidVehicleName: {
        id: 'app.invalidVehicleName',
        defaultMessage: 'Invalid vehicle name',
        description: 'Invalid Vehicle Name'
    },
    invalidVehicleNumber: {
        id: 'app.invalidVehicleNumber',
        defaultMessage: 'Invalid vehicle number',
        description: 'Invalid Vehicle Number'
    },
    vehicleNameError3: {
        id: 'app.vehicleNameError3',
        defaultMessage: 'Vehicle name must be minimum 3 characters and maximum 15 characters',
        description: 'New Password must be minimum 8 characters'
    },
    manageDashboard: {
        id: 'app.manageDashboard',
        defaultMessage: 'Dashboard',
        description: 'Manage Dashboard'
    },
    chooseFile: {
        id: 'app.chooseFile',
        defaultMessage: 'Choose file',
        description: ''
    },
    categoryIcon: {
        id: 'app.categoryIcon',
        defaultMessage: 'Category icon',
        description: ''
    },
    categoryMapMarker: {
        id: 'app.categoryMapMarker',
        defaultMessage: 'Category map marker',
        description: ''
    },
    maximumUploadSizeLabel: {
        id: 'app.maximumUploadSizeLabel',
        defaultMessage: 'Maximum upload size',
        description: ''
    },
    followUs: {
        id: 'app.followUs',
        defaultMessage: 'Follow  Us',
        description: 'Follow Us',
    },
    copyRights: {
        id: 'app.copyRights',
        defaultMessage: 'Wooberly 2020. All Rights Reserved',
        description: 'Copy Rights',
    },
    useFullLink: {
        id: 'app.useFullLink',
        defaultMessage: 'Usefull links',
        description: 'Usefull Links',
    },
    startRideing: {
        id: 'app.startRideing',
        defaultMessage: 'Start riding',
        description: 'Start Riding',
    },
    startDriving: {
        id: 'app.startDriving',
        defaultMessage: 'Start driving',
        description: 'Start Driving',
    },
    privacyPolicies: {
        id: 'app.privacyPolicies',
        defaultMessage: 'Privacy policy',
        description: 'Privacy Policy',
    },
    aboutFooterDesc: {
        id: 'app.aboutFooterDesc',
        defaultMessage: 'An cum maiorum repudiandae, cu eam dolore bonorum probatus. Et legere sanctus cum, quot nostrud postulant ex mei. Ad ullum audire admodum eos. Ne eam quod habeo aeque, ad decoreos.',
        description: 'aboutFooterDesc',
    },
    downloadAppText: {
        id: 'app.downloadAppText',
        defaultMessage: 'Download the rider app',
        description: 'DownloadAppText',
    },
    downloadAppTextDriver: {
        id: 'app.downloadAppTextDriver',
        defaultMessage: 'Download the driver app',
        description: 'DownloadAppText',
    },
    downloadAppDesc: {
        id: 'app.downloadAppDesc',
        defaultMessage: 'Delectus scaevola elaboraret vel ad, vis no noster vocent prodesset, nec ei omittantur dissentiet. Nobis postea ei est.',
        description: 'DownloadAppTextDesc',
    },
    downloadAppDriverDesc: {
        id: 'app.downloadAppDriverDesc',
        defaultMessage: 'Delectus scaevola elaboraret vel ad, vis no noster vocent prodesset, nec ei omittantur dissentiet. Nobis postea ei est.',
        description: 'DownloadAppTextDesc',
    },
    sliderTitle: {
        id: 'app.sliderTitle',
        defaultMessage: 'Lorem Ipsum',
        description: 'sliderTitle',
    },
    sliderTitleDesc: {
        id: 'app.sliderTitleDesc',
        defaultMessage: 'Percipit repudiandae an eum, enim case eos no. Percipit tractatos pertinacia cum id, ad eos facete malorum recusabo, vis insolens perpetua definitionem ex.',
        description: 'sliderTitleDesc',
    },
    rider: {
        id: 'app.rider',
        defaultMessage: 'Rider',
        description: 'Rider',
    },
    driver: {
        id: 'app.driver',
        defaultMessage: 'Driver',
        description: 'driver',
    },
    homeContent: {
        id: 'app.homeContent',
        defaultMessage: 'Start riding with wooberly',
        description: 'Start Riding With Wooberly',
    },
    gridTitleOne: {
        id: 'app.gridTitle',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleTwo: {
        id: 'app.gridTitleTwo',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleThree: {
        id: 'app.gridTitleThree',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleFour: {
        id: 'app.gridTitleFour',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleFive: {
        id: 'app.gridTitleFive',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridTitleSix: {
        id: 'app.gridTitleSix',
        defaultMessage: 'Lorem Ipsum',
        description: 'GridTitle',
    },
    gridDescOne: {
        id: 'app.gridDescOne',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescTwo: {
        id: 'app.gridDescTwo',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescThree: {
        id: 'app.gridDescThree',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescFour: {
        id: 'app.gridDescFour',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescFive: {
        id: 'app.gridDescFive',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    gridDescSix: {
        id: 'app.gridDescSix',
        defaultMessage: 'Id per gloriatur tincidunt. Vim odio unum atomorum at. Ut essent dicunt dolorum mei.',
        description: 'Grid Description',
    },
    drivers: {
        id: 'app.drivers',
        defaultMessage: 'Drivers',
        description: 'drivers',
    },
    today: {
        id: 'app.today',
        defaultMessage: 'Last 24 hours',
        description: 'Last 24 hours',
    },
    weekly: {
        id: 'app.weekly',
        defaultMessage: 'This week',
        description: 'weekly',
    },
    montly: {
        id: 'app.montly',
        defaultMessage: 'This month',
        description: 'montly',
    },
    riders: {
        id: 'app.riders',
        defaultMessage: 'Riders',
        description: 'Riders',
    },
    bookings: {
        id: 'app.bookings',
        defaultMessage: 'Bookings',
        description: 'bookings',
    },

    logout: {
        id: 'app.logout',
        defaultMessage: 'Logout',
        description: 'logout option',
    },

    goToMainSite: {
        id: 'app.goToMainSite',
        defaultMessage: 'Go to main site',
        description: 'goToMainSite option',
    },

    managePromoCode: {
        id: 'app.managePromoCode',
        defaultMessage: 'Manage promo code',
        description: 'managePromoCode sidemenu',
    },
    addPromoCode: {
        id: 'app.addPromoCode',
        defaultMessage: 'Add promo code',
        description: 'Add PromoCode',
    },
    editPromoCode: {
        id: 'app.editPromoCode',
        defaultMessage: 'Edit promo code',
        description: 'Edit PromoCode',
    },
    addPage: {
        id: 'app.addPage',
        defaultMessage: "Add page",
        description: "Add Page"
    },
    id: {
        id: 'app.id',
        defaultMessage: 'ID',
        description: 'ID text',
    },
    title: {
        id: 'app.title',
        defaultMessage: 'Title',
        description: 'text',
    },
    description: {
        id: 'app.description',
        defaultMessage: 'Description',
        description: 'text',
    },
    code: {
        id: 'app.code',
        defaultMessage: 'Code',
        description: 'text',
    },
    discount: {
        id: 'app.discount',
        defaultMessage: 'Discount',
        description: 'text',
    },
    promoType: {
        id: 'app.promoType',
        defaultMessage: 'Type',
        description: 'text',
    },
    expireDate: {
        id: 'app.expireDate',
        defaultMessage: 'Expiry date',
        description: 'text',
    },
    percentage: {
        id: 'app.percentage',
        defaultMessage: 'Percentage',
        description: 'text',
    },
    fixedAmount: {
        id: 'app.fixedAmount',
        defaultMessage: 'Fixed amount',
        description: 'text',
    },
    usedPromoCode: {
        id: 'app.usedPromoCode',
        defaultMessage: 'Used promo code',
        description: 'text',
    },
    manageCompletedTrips: {
        id: 'app.manageCompletedTrips',
        defaultMessage: 'Completed bookings',
        description: 'CompletedTrips sidemenu',
    },
    manageCancelledTrips: {
        id: 'app.manageCancelledTrips',
        defaultMessage: 'Cancelled bookings',
        description: 'manageCancelledTrips sidemenu',
    },
    manageCancelReason: {
        id: 'app.manageCancelReason',
        defaultMessage: 'Cancel reason',
        description: 'Cancel Reason',
    },
    manageCurrency: {
        id: 'app.manageCurrency',
        defaultMessage: 'Manage currency',
        description: 'manageCurrency sidemenu',
    },
    symbol: {
        id: 'app.symbol',
        defaultMessage: 'Symbol',
        description: 'currencyManagement value',
    },
    baseCurrency: {
        id: 'app.BaseCurrency',
        defaultMessage: 'Base currency',
        description: 'currencyManagement value',
    },
    enableDisable: {
        id: 'app.enableDisable',
        defaultMessage: 'Set Enable / Disable',
        description: 'currencyManagement value',
    },
    setBaseCurrency: {
        id: 'app.setBaseCurrency',
        defaultMessage: 'Set base currency',
        description: 'currencyManagement value',
    },
    allowedPaymentCurrency: {
        id: 'app.allowedPaymentCurrency',
        defaultMessage: 'Allowed payment currency',
        description: 'currencyManagement value',
    },
    reviewsBy: {
        id: 'app.reviewsBy',
        defaultMessage: 'Reviews by',
        description: 'reviewsBy'
    },
    noResult: {
        id: 'app.noResult',
        defaultMessage: 'No results found',
        description: 'noResult'
    },
    addLocation: {
        id: 'app.addLocation',
        defaultMessage: 'Add location',
        description: 'addLocation'
    },
    tollFee: {
        id: 'app.tollFee',
        defaultMessage: 'Toll fee',
        description: 'tollFee'
    },
    location: {
        id: 'app.location',
        defaultMessage: 'Manage location',
        description: 'location'
    },
    edit: {
        id: 'app.edit',
        defaultMessage: 'Edit',
        description: 'edit'
    },
    managePayout: {
        id: 'app.managePayout',
        defaultMessage: 'Manage payout',
        description: 'managePayout'
    },
    drivPayout: {
        id: 'app.drivPayout',
        defaultMessage: 'Driver payout',
        description: 'managePayout'
    },
    amount: {
        id: 'app.Amount',
        defaultMessage: 'Amount',
        description: 'Amount'
    },
    payoutStatus: {
        id: 'app.payoutStatus',
        defaultMessage: 'Payout status',
        description: 'Payout Status'
    },
    holdPayout: {
        id: 'app.holdPayout',
        defaultMessage: 'Hold payout',
        description: 'Hold Payout'
    },
    paymentType: {
        id: 'app.paymentType',
        defaultMessage: 'Payment type',
        description: 'Payment Type'
    },
    yes: {
        id: 'app.yes',
        defaultMessage: 'Yes',
        description: 'Yes'
    },
    no: {
        id: 'app.no',
        defaultMessage: 'No',
        description: 'no'
    },
    homeSectionSettings: {
        id: 'app.homeSectionSettings',
        defaultMessage: 'Banner',
        description: 'Banner Settings'
    },
    homepageBanner: {
        id: 'app.homepageBanner',
        defaultMessage: 'Banner',
        description: 'Homepage Banner Settings'
    },
    aboutSectionSettings: {
        id: 'app.aboutSectionSettings',
        defaultMessage: 'Top features',
        description: 'Top Features Settings'
    },
    citySectionSettings: {
        id: 'app.citySectionSettings',
        defaultMessage: 'Category',
        description: 'Category Settings'
    },
    safetySectionSettings: {
        id: 'app.safetySectionSettings',
        defaultMessage: 'Rider app',
        description: 'Rider Apps Settings'
    },
    signupSectionSettings: {
        id: 'app.signupSectionSettings',
        defaultMessage: 'Driver app',
        description: 'Driver Apps Settings'
    },
    footerSectionSettings: {
        id: 'app.footerSectionSettings',
        defaultMessage: 'Footer',
        description: 'Footer Settings'
    },
    manageFailedPayout: {
        id: 'app.manageFailedPayout',
        defaultMessage: 'Failed payout',
        description: 'Failed Payout'
    },
    title1: {
        id: 'app.title1',
        defaultMessage: 'Title 1',
        description: 'Title 1'
    },
    title2: {
        id: 'app.title2',
        defaultMessage: 'Title 2',
        description: 'Title 2'
    },
    title3: {
        id: 'app.title3',
        defaultMessage: 'Title 3',
        description: 'Title 3'
    },
    title4: {
        id: 'app.title4',
        defaultMessage: 'Title 4',
        description: 'Title 4'
    },
    title5: {
        id: 'app.title5',
        defaultMessage: 'Title 5',
        description: 'Title 5'
    },
    title6: {
        id: 'app.title6',
        defaultMessage: 'Title 6',
        description: 'Title 6'
    },
    content: {
        id: 'app.content',
        defaultMessage: 'Content',
        description: 'Content 1'
    },
    content1: {
        id: 'app.content1',
        defaultMessage: 'Content 1',
        description: 'Content 1'
    },
    content2: {
        id: 'app.content2',
        defaultMessage: 'Content 2',
        description: 'Content 2'
    },
    content3: {
        id: 'app.content3',
        defaultMessage: 'Content 3',
        description: 'Content 3'
    },
    content4: {
        id: 'app.content4',
        defaultMessage: 'Content 4',
        description: 'Content 4'
    },
    content5: {
        id: 'app.content5',
        defaultMessage: 'Content 5',
        description: 'Content 5'
    },
    content6: {
        id: 'app.content6',
        defaultMessage: 'Content 6',
        description: 'Content 6'
    },
    button: {
        id: 'app.button',
        defaultMessage: 'Button',
        description: 'Button'
    },
    aboutImage1: {
        id: 'app.aboutImage1',
        defaultMessage: 'Feature banner',
        description: 'Feature Banner 1'
    },
    aboutImage2: {
        id: 'app.aboutImage2',
        defaultMessage: 'Feature icon #1',
        description: 'Feature Banner 2'
    },
    homeImage1: {
        id: 'app.homeImage1',
        defaultMessage: 'Banner image #1',
        description: 'Banner Image 1'
    },
    homeImage2: {
        id: 'app.homeImage2',
        defaultMessage: 'Banner image #2',
        description: 'Banner Image 2'
    },
    homeImage3: {
        id: 'app.homeImage3',
        defaultMessage: 'Banner image #3',
        description: 'Banner Image 3'
    },
    homeImage4: {
        id: 'app.homeImage4',
        defaultMessage: 'Banner image #4',
        description: 'Banner Image 4'
    },
    homeImage5: {
        id: 'app.homeImage5',
        defaultMessage: 'Banner image #5',
        description: 'Banner Image 5'
    },
    homeImage6: {
        id: 'app.homeImage6',
        defaultMessage: 'Banner image',
        description: 'Banner Image 6'
    },
    homeImage7: {
        id: 'app.homeImage7',
        defaultMessage: 'Banner image tablet',
        description: 'Banner Image Tablet'
    },
    homeImage8: {
        id: 'app.homeImage8',
        defaultMessage: 'Banner image mobile',
        description: 'Banner Image Mobile'
    },
    homeTitle: {
        id: 'app.homeTitle',
        defaultMessage: 'Banner title',
        description: 'Banner Title'
    },
    homeContent1: {
        id: 'app.homeContent1',
        defaultMessage: 'Banner content',
        description: 'Banner Content'
    },
    safetyImage1: {
        id: 'app.safetyImage1',
        defaultMessage: 'Playstore logo',
        description: 'Playstore Logo'
    },
    safetyImage2: {
        id: 'app.safetyImage2',
        defaultMessage: 'Appstore logo',
        description: 'Appstore Logo'
    },
    safetyImage3: {
        id: 'app.safetyImage3',
        defaultMessage: 'Rider banner',
        description: 'Rider Banner'
    },
    signupImage1: {
        id: 'app.signupImage1',
        defaultMessage: 'Playstore logo',
        description: 'Playstore Logo'
    },
    signupImage2: {
        id: 'app.signupImage2',
        defaultMessage: 'Appstore logo',
        description: 'Appstore Logo'
    },
    signupImage3: {
        id: 'app.signupImage3',
        defaultMessage: 'Driver banner',
        description: 'Driver Banner'
    },
    footerLogo1: {
        id: 'app.footerLogo1',
        defaultMessage: 'Image banner',
        description: 'Footer Logo 1'
    },
    footerLogo2: {
        id: 'app.footerLogo2',
        defaultMessage: 'Footer logo #2',
        description: 'Footer Logo 2'
    },
    footerLogo3: {
        id: 'app.footerLogo3',
        defaultMessage: 'Footer logo #3',
        description: 'Footer Logo 3'
    },
    footerLogo4: {
        id: 'app.footerLogo4',
        defaultMessage: 'Footer logo #4',
        description: 'Footer Logo 4'
    },
    tipsAmount: {
        id: 'app.tipsAmount',
        defaultMessage: 'Tips amount',
        description: 'Tips Amount'
    },
    earnings: {
        id: 'app.earnings',
        defaultMessage: 'Your earnings',
        description: 'Earnings'
    },
    overAll: {
        id: 'app.overAll',
        defaultMessage: 'Overall',
        description: 'Overall'
    },
    approve: {
        id: 'app.approve',
        defaultMessage: 'Approve',
        description: 'Approve'
    },
    decline: {
        id: 'app.decline',
        defaultMessage: 'Decline',
        description: 'Decline'
    },
    online: {
        id: 'app.online',
        defaultMessage: 'Online',
        description: 'online'
    },
    offline: {
        id: 'app.offline',
        defaultMessage: 'Offline',
        description: 'offline'
    },
    eligibleForATrip: {
        id: 'app.eligibleForATrip',
        defaultMessage: 'Eligible for a trip',
        description: 'text'
    },
    notEligibleForATrip: {
        id: 'app.notEligibleForATrip',
        defaultMessage: 'Not eligible for a trip',
        description: 'text'
    },
    preview: {
        id: 'app.preview',
        defaultMessage: 'Preview',
        description: 'Preview'
    },
    pageName: {
        id: 'app.pageName',
        defaultMessage: 'Page Name',
        description: 'Page Name'
    },
    staticpageManagement: {
        id: 'app.staticpageManagement',
        defaultMessage: 'Manage static content',
        description: 'Manage Static Content'
    },
    contentpageManagement: {
        id: 'app.contentpageManagement',
        defaultMessage: 'Content management',
        description: 'Content Management'
    },
    editPageDetails: {
        id: 'app.editPageDetails',
        defaultMessage: 'Edit page details',
        description: 'Edit Page Details'
    },
    pageBanner: {
        id: 'app.pageBanner',
        defaultMessage: 'Page banner',
        description: 'Page Banner'
    },
    pageImageBanner: {
        id: 'app.pageImageBanner',
        defaultMessage: 'Page image banner',
        description: 'Page Image Banner'
    },
    manageFare: {
        id: 'app.manageFare',
        defaultMessage: 'Manage fare',
        description: 'Admin sidemenu'
    },
    locationName: {
        id: 'app.locationName',
        defaultMessage: 'Location',
        description: 'Table header'
    },
    addFare: {
        id: 'app.addFare',
        defaultMessage: 'Add fare',
        description: 'Button '
    },
    editFare: {
        id: 'app.adeditFaredFare',
        defaultMessage: 'Edit fare',
        description: 'Button '
    },
    vechicleName: {
        id: 'app.vechicleName',
        defaultMessage: 'Vehicle',
        description: 'Vehicle'
    },
    paid: {
        id: 'app.paid',
        defaultMessage: 'Paid',
        description: 'Paid'
    },
    unpaid: {
        id: 'app.unpaid',
        defaultMessage: 'Unpaid',
        description: 'Unpaid'
    },
    payoutAmount: {
        id: 'app.payoutAmount',
        defaultMessage: 'Payout amount',
        description: 'Payout Amount'
    },
    searchLocation: {
        id: 'app.searchLocation',
        defaultMessage: 'Search location',
        description: 'Auto-Complete input'
    },
    removeLocation: {
        id: 'app.removeLocation',
        defaultMessage: 'Remove location',
        description: 'Polygon remove'
    },
    walletBalance: {
        id: 'app.walletBalance',
        defaultMessage: 'Wallet balance',
        description: 'Wallet Balance'
    },
    paymentMethod: {
        id: 'app.paymentMethod',
        defaultMessage: 'Payment method',
        description: 'Payment Method'
    },
    card: {
        id: 'app.card',
        defaultMessage: 'Card',
        description: 'Card'
    },
    cash: {
        id: 'app.cash',
        defaultMessage: 'Cash',
        description: 'Cash'
    },
    wallet: {
        id: 'app.wallet',
        defaultMessage: 'Wallet',
        description: 'Wallet'
    },
    exportDataIntoCSV: {
        id: 'app.exportDataIntoCSV',
        defaultMessage: 'Export data into CSV',
        description: 'Export Data into CSV',
    },
    roleName: {
        id: 'app.roleName',
        defaultMessage: 'Role name',
        description: 'Role Name',
    },
    privileges: {
        id: 'app.privileges',
        defaultMessage: 'Privileges',
        description: 'Privileges',
    },
    emailText: {
        id: 'app.emailText',
        defaultMessage: 'Email',
        description: 'Email',
    },
    adminRole: {
        id: 'app.adminRole',
        defaultMessage: 'Admin role',
        description: 'Admin Role',
    },
    adminName: {
        id: 'app.adminName',
        defaultMessage: 'Name',
        description: 'Name'
    },
    passwordText: {
        id: 'app.passwordText',
        defaultMessage: 'Provide new password only. Ignore this field to use the existing password for this user.',
        description: 'Password Content',
    },
    selectRole: {
        id: 'app.selectRole',
        defaultMessage: 'Select role',
        description: 'Select Role',
    },
    role: {
        id: 'app.role',
        defaultMessage: 'Role',
        description: 'Role',
    },
    manageAdmin: {
        id: 'app.manageAdmin',
        defaultMessage: 'Manage admins',
        description: 'Manage Admins',
    },
    manageAdminUsers: {
        id: 'app.manageAdminUsers',
        defaultMessage: 'Manage admin users',
        description: 'Manage Admin Users',
    },
    manageAdminRoles: {
        id: 'app.manageAdminRoles',
        defaultMessage: 'Manage admin roles',
        description: 'Manage Admin Roles',
    },
    adminUserLabel: {
        id: 'app.adminUserLabel',
        defaultMessage: 'Admin user',
        description: 'Admin User',
    },
    addNewLabel: {
        id: 'app.addNewLabel',
        defaultMessage: 'Add new',
        description: 'Add New',
    },
    chooseLanguageLabel: {
        id: 'app.chooseLanguageLabel',
        defaultMessage: 'Choose a language',
        description: 'Choose a Language',
    },
    askQuestion: {
        id: 'app.askQuestion',
        defaultMessage: 'Ask a question',
        description: 'Ban Status'
    },
    reportIssue: {
        id: 'app.reportIssue',
        defaultMessage: 'Report an issue',
        description: 'Ban Status'
    },
    Enabled: {
        id: 'app.Enabled',
        defaultMessage: 'Enabled',
        description: 'Ban Status'
    },
    Disabled: {
        id: 'app.Disabled',
        defaultMessage: 'Disabled',
        description: 'Ban Status'
    },
    Enable: {
        id: 'app.Enable',
        defaultMessage: 'Enable',
        description: 'Ban Status'
    },
    Disable: {
        id: 'app.Disable',
        defaultMessage: 'Disable',
        description: 'Ban Status'
    },
    setBase: {
        id: 'app.setBase',
        defaultMessage: 'Set as base currency',
        description: 'Ban Status'
    },
    Support: {
        id: 'app.Support',
        defaultMessage: 'Support',
        description: 'Ban Status'
    },
    totalUser: {
        id: 'app.totalUser',
        defaultMessage: 'Total users',
        description: 'Ban Status'
    },
    totalList: {
        id: 'app.totalList',
        defaultMessage: 'Total listings',
        description: 'Ban Status'
    },
    totalReserv: {
        id: 'app.totalReserv',
        defaultMessage: 'Total reservations',
        description: 'Ban Status'
    },
    lastHours: {
        id: 'app.lastHours',
        defaultMessage: 'Last 24 hours',
        description: 'Ban Status'
    },
    listings: {
        id: 'app.listings',
        defaultMessage: 'Listings',
        description: 'Ban Status'
    },
    reservations: {
        id: 'app.reservations',
        defaultMessage: 'Reservations',
        description: 'Ban Status'
    },
    notFound: {
        id: 'app.notFound',
        defaultMessage: 'Sorry, the page you were trying to view does not exist.',
        description: 'Ban Status'
    },
    oneOne: {
        id: 'app.oneOne',
        defaultMessage: 'One',
        description: 'Ban Status'
    },
    currencies: {
        id: 'app.currencies',
        defaultMessage: 'Currencies',
        description: 'Ban Status'
    },
    fares: {
        id: 'app.fares',
        defaultMessage: 'Fares',
        description: 'Fares'
    },
    vehicles: {
        id: 'app.vehicles',
        defaultMessage: 'Vehicles',
        description: 'Fares'
    },
    homeonly: {
        id: 'app.homeonly',
        defaultMessage: 'Home',
        description: 'Fares'
    },
    allonly: {
        id: 'app.allonly',
        defaultMessage: 'All',
        description: 'Fares'
    },
    playstorelink: {
        id: 'app.playstorelink',
        defaultMessage: 'Play store link',
        description: 'Fares'
    },
    appstorelink: {
        id: 'app.appstorelink',
        defaultMessage: 'App store link',
        description: 'Fares'
    },
    driverappcntn: {
        id: 'app.driverappcntn',
        defaultMessage: 'Driver app content',
        description: 'Fares'
    },
    driverapptitle: {
        id: 'app.driverapptitle',
        defaultMessage: 'Driver app title',
        description: 'Fares'
    },
    logowidth: {
        id: 'app.logowidth',
        defaultMessage: 'Logo width',
        description: 'Fares'
    },
    logoheight: {
        id: 'app.logoheight',
        defaultMessage: 'Logo height',
        description: 'Fares'
    },
    siteName: {
        id: 'app.siteName',
        defaultMessage: 'Site name',
        description: 'Fares'
    },
    siteTitle: {
        id: 'app.siteTitle',
        defaultMessage: 'Site title',
        description: 'Fares'
    },
    metakey: {
        id: 'app.metakey',
        defaultMessage: 'Meta keyword',
        description: 'Fares'
    },
    metaDesc: {
        id: 'app.metaDesc',
        defaultMessage: 'Meta description',
        description: 'Fares'
    },
    facebookUrl: {
        id: 'app.facebookUrl',
        defaultMessage: 'Facebook URL',
        description: 'Fares'
    },
    twiterUrl: {
        id: 'app.twiterUrl',
        defaultMessage: 'Twitter URL',
        description: 'Fares'
    },
    instaUrl: {
        id: 'app.instaUrl',
        defaultMessage: 'Instagram URL',
        description: 'Fares'
    },
    youtubeUrl: {
        id: 'app.youtubeUrl',
        defaultMessage: 'Youtube URL',
        description: 'Fares'
    },
    miles: {
        id: 'app.miles',
        defaultMessage: 'Miles',
        description: 'Fares'
    },
    errorOnly: {
        id: 'app.errorOnly',
        defaultMessage: 'Error',
        description: 'Fares'
    },
    credentialError: {
        id: 'app.credentialError',
        defaultMessage: 'Sorry, a critical error occurred on this page.',
        description: 'Fares'
    },
    addOnly: {
        id: 'app.addOnly',
        defaultMessage: 'Address',
        description: 'Fares'
    },
    state: {
        id: 'app.state',
        defaultMessage: 'State',
        description: 'Fares'
    },
    checkmein: {
        id: 'app.checkmein',
        defaultMessage: 'Check me in',
        description: 'Fares'
    },
    checkmeout: {
        id: 'app.checkmeout',
        defaultMessage: 'Check me out',
        description: 'Fares'
    },
    tableHead: {
        id: 'app.tableHead',
        defaultMessage: 'Table heading',
        description: 'Fares'
    },
    tableCell: {
        id: 'app.tableCell',
        defaultMessage: 'Table cell',
        description: 'Fares'
    },
    redioOne: {
        id: 'app.redioOne',
        defaultMessage: 'radio 1',
        description: 'Fares'
    },
    optionOne: {
        id: 'app.optionOne',
        defaultMessage: 'option 1',
        description: 'Fares'
    },
    confirmPassword: {
        id: 'app.confirmPassword',
        defaultMessage: 'Confirm password',
        description: 'Change Password'
    },
    nameOnly: {
        id: 'app.nameOnly',
        defaultMessage: 'Name',
        description: 'Name'
    },
    msgOnly: {
        id: 'app.msgOnly',
        defaultMessage: 'Message',
        description: 'Message'
    },
    featureTitle1: {
        id: 'app.featureTitle1',
        defaultMessage: 'Feature title',
        description: 'Change Password'
    },
    featureTitle2: {
        id: 'app.featureTitle2',
        defaultMessage: 'Feature title #1',
        description: 'Change Password'
    },
    featureTitle3: {
        id: 'app.featureTitle3',
        defaultMessage: 'Feature title #2',
        description: 'Change Password'
    },
    featureTitle4: {
        id: 'app.featureTitle4',
        defaultMessage: 'Feature title #3',
        description: 'Change Password'
    },
    featureTitle5: {
        id: 'app.featureTitle5',
        defaultMessage: 'Feature title #5',
        description: 'Change Password'
    },
    featureTitle6: {
        id: 'app.featureTitle6',
        defaultMessage: 'Feature title #6',
        description: 'Change Password'
    },
    featureDesc1: {
        id: 'app.featureDesc1',
        defaultMessage: 'Feature description',
        description: 'Change Password'
    },
    featureDesc2: {
        id: 'app.featureDesc2',
        defaultMessage: 'Feature description #1',
        description: 'Change Password'
    },
    featureDesc3: {
        id: 'app.featureDesc3',
        defaultMessage: 'Feature description #2',
        description: 'Change Password'
    },
    featureDesc4: {
        id: 'app.featureDesc4',
        defaultMessage: 'Feature description #3',
        description: 'Change Password'
    },
    featureDesc5: {
        id: 'app.featureDesc5',
        defaultMessage: 'Feature description #5',
        description: 'Change Password'
    },
    featureDesc6: {
        id: 'app.featureDesc6',
        defaultMessage: 'Feature description #6',
        description: 'Change Password'
    },
    footerTitle1: {
        id: 'app.footerTitle1',
        defaultMessage: 'Footer title',
        description: 'Change Password'
    },
    footerContent1: {
        id: 'app.footerContent1',
        defaultMessage: 'Footer content',
        description: 'Change Password'
    },
    footerUrltitle: {
        id: 'app.footerUrltitle',
        defaultMessage: 'Footer URL title',
        description: 'Change Password'
    },
    copyRightcontent: {
        id: 'app.copyRightcontent',
        defaultMessage: 'Copyrights content',
        description: 'Change Password'
    },
    radioButton: {
        id: 'app.radioButton',
        defaultMessage: 'Radio button',
        description: 'Change Password'
    },
    buttonLabel: {
        id: 'app.buttonLabel',
        defaultMessage: 'Button label',
        description: 'Change Password'
    },
    riderApptitle: {
        id: 'app.riderApptitle',
        defaultMessage: 'Rider app title',
        description: 'Change Password'
    },
    riderAppContent: {
        id: 'app.riderAppContent',
        defaultMessage: 'Rider app content',
        description: 'Change Password'
    },
    leaveEmail: {
        id: 'app.leaveEmail',
        defaultMessage: 'Leave email address field blank if you don\'t want to change the email',
        description: 'Change Password'
    },
    searchOnly: {
        id: 'app.searchOnly',
        defaultMessage: 'Search',
        description: 'Change Password'
    },
    add: {
        id: 'app.add',
        defaultMessage: 'Add',
        description: 'Add Button',
    },
    topFeatures: {
        id: 'app.topFeatures',
        defaultMessage: 'Top features section settings',
        description: 'Top Features Section Settings',
    },
    driverPayout: {
        id: 'app.driverPayout',
        defaultMessage: 'Manage driver payouts',
        description: 'Manage Driver Payouts'
    },
    changeAdminPassword: {
        id: 'app.changeAdminPassword',
        defaultMessage: 'Change admin email/password',
        description: 'Change Admin Email/Password'
    },
    currencyList: {
        id: 'app.currencyList',
        defaultMessage: 'Currency list',
        description: 'Currency List'
    },
    editLocation: {
        id: 'app.editLocation',
        defaultMessage: 'Edit location',
        description: 'Edit Location'
    },
    bookingDetails: {
        id: 'app.bookingDetails',
        defaultMessage: 'Booking details',
        description: 'Booking Details'
    },
    riderAndriodVersion: {
        id: 'app.riderAndriodVersion',
        defaultMessage: 'Rider Android version',
        description: 'riderAndriodVersion'
    },
    rideriosVersion: {
        id: 'app.rideriosVersion',
        defaultMessage: 'Rider iOS version',
        description: 'rideriosVersion'
    },
    driverAndriodVersion: {
        id: 'app.driverAndriodVersion',
        defaultMessage: 'Driver Android version',
        description: 'Andriod'
    },
    driveriosVersion: {
        id: 'app.driveriosVersion',
        defaultMessage: 'Driver iOS version',
        description: 'iOS'
    },
    forceUpdate: {
        id: 'app.forceUpdate',
        defaultMessage: 'Force update',
        description: 'forceUpdate'
    },
    invalidVersionNumber: {
        id: 'app.invalidVersionNumber',
        defaultMessage: 'Invalid version number',
        description: 'invalidVersionNumber'
    },
    to: {
        id: 'app.to',
        defaultMessage: 'To',
        description: 'Label'
    },
    validatePasswordLength: {
        id: 'app.validatePasswordLength',
        defaultMessage: 'Password must be minimum 8 characters',
        description: 'Password length Validation'
    },
    validateConfirmPasswordLength: {
        id: 'app.validateConfirmPasswordLength',
        defaultMessage: 'Confirm password must be minimum 8 characters',
        description: 'Confirm Password length Validation'
    },
    validatePasswordMatch: {
        id: 'app.validatePasswordMatch',
        defaultMessage: 'Password is mismatching with confirm password',
        description: 'Password mismatch'
    },
    rideFare: {
        id: 'app.rideFare',
        defaultMessage: 'Ride fare',
        description: 'Label'
    },
    riderBillingInformation: {
        id: 'app.riderBillingInformation',
        defaultMessage: 'Rider billing information',
        description: 'Label'
    },
    driverBillingInformation: {
        id: 'app.driverBillingInformation',
        defaultMessage: 'Driver billing information',
        description: 'Label'
    },
    driverEarnings: {
        id: 'app.driverEarnings',
        defaultMessage: 'Driver earnings',
        description: 'Label'
    },
    tipsReceivedFromRider: {
        id: 'app.tipsReceivedFromRider',
        defaultMessage: 'Tips received from the rider',
        description: 'Label'
    },
    tipsGivenToDriver: {
        id: 'app.tipsGivenToDriver',
        defaultMessage: 'Tips given to the driver',
        description: 'Label'
    },
    platformEarnings: {
        id: 'app.platformEarnings',
        defaultMessage: 'Platform earnings',
        description: 'Label'
    },
    platformOffered: {
        id: 'app.platformOffered',
        defaultMessage: 'Platform overdrafts',
        description: 'Label'
    },
    processedCash: {
        id: 'app.processedCash',
        defaultMessage: 'Processed via cash',
        description: 'Label'
    },
    completedLabel: {
        id: 'app.completedLabel',
        defaultMessage: 'Completed',
        description: 'Label'
    },
    pendingLabel: {
        id: 'app.pendingLabel',
        defaultMessage: 'Pending',
        description: 'Label'
    },
    notRequired: {
        id: 'app.notRequired',
        defaultMessage: 'No action required',
        description: 'Label'
    },
    walletBalance: {
        id: 'app.walletBalance',
        defaultMessage: 'Wallet balance',
        description: 'Wallet Balance'
    },
    paymentMethod: {
        id: 'app.paymentMethod',
        defaultMessage: 'Payment method',
        description: 'Payment Method'
    },
    card: {
        id: 'app.card',
        defaultMessage: 'Card',
        description: 'Card'
    },
    cash: {
        id: 'app.cash',
        defaultMessage: 'Cash',
        description: 'Cash'
    },
    wallet: {
        id: 'app.wallet',
        defaultMessage: 'Wallet',
        description: 'Wallet'
    },
    exportDataIntoCSV: {
        id: 'app.exportDataIntoCSV',
        defaultMessage: 'Export data into CSV',
        description: 'Export Data into CSV',
    },
    addAdminRole: {
        id: 'app.addAdminRole',
        defaultMessage: 'Add admin role',
        description: 'Title'
    },
    editAdminRole: {
        id: 'app.editAdminRole',
        defaultMessage: 'Edit admin role',
        description: 'Title'
    },
    locations: {
        id: 'app.locations',
        defaultMessage: 'Locations',
        description: 'Pagination'
    },
    addAdminUserLabel: {
        id: 'app.addAdminUserLabel',
        defaultMessage: 'Add admin user',
        description: 'Add Admin User'
    },
    editAdminUserLabel: {
        id: 'app.editAdminUserLabel',
        defaultMessage: 'Edit admin user',
        description: 'Edit Admin User'
    },
    completed: {
        id: 'app.completed',
        defaultMessage: 'Completed',
        description: 'Completed Status'
    },
    approved: {
        id: 'app.approved',
        defaultMessage: 'Approved',
        description: 'Approved Status'
    },
    declined: {
        id: 'app.declined',
        defaultMessage: 'Declined',
        description: 'Declined Status'
    },
    started: {
        id: 'app.started',
        defaultMessage: 'Started',
        description: 'Started Status'
    },
    cancelledByRider: {
        id: 'app.cancelledByRider',
        defaultMessage: 'Cancelled by rider',
        description: 'Cancelled By Rider Status'
    },
    cancelledByDriver: {
        id: 'app.cancelledByDriver',
        defaultMessage: 'Cancelled by driver',
        description: 'Cancelled By Driver Status'
    },
    locationReached: {
        id: 'app.locationReached',
        defaultMessage: 'Reached',
        description: 'LocationReached Status'
    },
    expired: {
        id: 'app.expired',
        defaultMessage: 'Expired',
        description: 'Expired Status'
    },
    notRequiredMessage: {
        id: 'app.notRequiredMessage',
        defaultMessage: 'Not required',
        description: 'Not Required'
    },
    driverPrivacyPolicy: {
        id: 'app.driverPrivacyPolicy',
        defaultMessage: 'Driver privacy policy',
        description: 'Title',
    },
    precautionNotification: {
        id: 'app.precautionNotification',
        defaultMessage: 'Precaution notification',
        description: 'Title',
    },
    image: {
        id: 'app.image',
        defaultMessage: 'Image',
        description: 'Label',
    },
    scheduleBooking: {
        id: 'app.scheduleBooking',
        defaultMessage: 'Schedule bookings',
        description: 'Label'
    },
    scheduled: {
        id: 'app.scheduled',
        defaultMessage: 'Scheduled',
        description: 'Trip status'
    },
    scheduledFrom: {
        id: 'app.scheduledFrom',
        defaultMessage: 'Scheduled From',
        description: 'Label'
    },
    scheduledTo: {
        id: 'app.scheduledTo',
        defaultMessage: 'Scheduled To',
        description: 'Label'
    },
    failed: {
        id: 'app.failed',
        defaultMessage: 'Failed',
        description: 'Trip Status of Schedule History'
    },
    updated: {
        id: 'app.updated',
        defaultMessage: 'Updated',
        description: 'Trip Status of Schedule History'
    },
    scheduleBookingHistory: {
        id: 'app.scheduleBookingHistory',
        defaultMessage: 'Schedule booking history',
        description: 'Heading'
    },
    updatedAt: {
        id: 'app.updatedAt',
        defaultMessage: 'Updated At',
        description: 'Label'
    },
    chatLabel: {
        id: 'app.chatLabel',
        defaultMessage: 'Chat',
        description: 'Chat'
    },
    chatMessageLabel: {
        id: 'app.chatMessageLabel',
        defaultMessage: 'Chat message',
        description: 'Chat Message'
    },
    stripePublishableKey: {
        id: 'app.stripePublishableKey',
        defaultMessage: 'Stripe publishable key',
        description: 'Stripe Publishable Key'
    },
    loadMoreMsg: {
        id: 'app.loadMoreMsg',
        defaultMessage: 'Load more',
        description: 'Load more button',
    },
    noItmesFound: {
        id: 'app.noItmesFound',
        defaultMessage: 'No items found',
        description: 'No items found',
    },
    preferredDistanceType: {
        id: 'app.Preferred Distance Type',
        defaultMessage: 'Preferred distance type',
        description: 'Preferred Distance Type',
    },
    multipleStopsWaitingTime: {
        id: 'app.multipleStopsWaitingTime',
        defaultMessage: 'Multiple stops waiting time',
        description: 'multipleStopsWaitingTime',
    },
    /**Loaded dynamically in View booking */
    km: {
        id: 'app.km',
        defaultMessage: 'Km',
        description: 'Km',
    },
    mile: {
        id: 'app.mile',
        defaultMessage: 'Mile',
        description: 'Mile',
    },
    /**Loaded dynamically in View booking */
    tracking: {
        id: 'app.tracking',
        defaultMessage: 'Tracking',
        description: 'tracking',
    },
    mapView: {
        id: 'app.mapView',
        defaultMessage: 'Map view',
        description: 'mapView',
    },
    heatMap: {
        id: 'app.heatMap',
        defaultMessage: 'HeatMap',
        description: 'heatMap',
    },
    all: {
        id: 'app.all',
        defaultMessage: 'All',
        description: 'all',
    },
    availableDrivers: {
        id: 'app.availableDrivers',
        defaultMessage: 'Available drivers',
        description: 'availableDrivers',
    },
    unAvailableDrivers: {
        id: 'app.unAvailableDrivers',
        defaultMessage: 'Unavailable drivers',
        description: 'unAvailableDrivers',
    },
    unActivatedDrivers: {
        id: 'app.unActivatedDrivers',
        defaultMessage: 'Unactivated drivers',
        description: 'unActivatedDrivers',
    },
    activeDrivers: {
        id: 'app.activeDrivers',
        defaultMessage: 'Active drivers',
        descrisite
    },
    mobileSettings: {
        id: 'app.mobileSettings',
        defaultMessage: 'Mobile app settings',
        description: 'Mobile App Settings'
    },
    distance: {
        id: 'app.distance',
        defaultMessage: 'Distance',
        description: 'Distance'
    },
    duration: {
        id: 'app.duration',
        defaultMessage: 'Duration',
        description: 'duration'
    },
    estimatedPrice: {
        id: 'app.estimatedPrice',
        defaultMessage: 'Estimated price',
        description: 'estimatedPrice'
    },
    pickupLocationLabel: {
        id: 'app.pickupLocationLabel',
        defaultMessage: 'Pick-up location',
        description: 'pickupLocationLabel'
    },
    destinationLocation: {
        id: 'app.destinationLocation',
        defaultMessage: 'Destination location',
        description: 'destinationLocation'
    },
    sleepDriverAndroid: {
        id: 'app.sleepDriverAndroid',
        defaultMessage: 'Driver Android app',
        description: 'sleepDriverAndroid'
    },
    sleepDriverios: {
        id: 'app.sleepDriverios',
        defaultMessage: 'Driver iOS app ',
        description: 'sleepDriverios'
    },
    show: {
        id: 'app.show',
        defaultMessage: 'Show',
        description: 'show'
    },
    hide: {
        id: 'app.hide',
        defaultMessage: 'Hide',
        description: 'hide'
    },
    tripRequestWindow: {
        id: 'app.tripRequestWindow',
        defaultMessage: 'Manage driver app trip request window',
        description: 'tripRequestWindow'
    },
    sleepMode: {
        id: 'app.sleepMode',
        defaultMessage: 'Manage driver app sleep mode',
        description: 'sleepMode'
    },
    stripeSettings: {
        id: 'app.stripeSettings',
        defaultMessage: 'Stripe settings',
        description: 'stripeSettings'
    },
    manageForceUpdate: {
        id: 'app.manageForceUpdate',
        defaultMessage: 'Manage apps force update',
        description: 'manageForceUpdate'
    },
    mulitStopSettings: {
        id: 'app.mulitStopSettings',
        defaultMessage: 'Multiple stops settings',
        description: 'mulitStopSettings'
    },
    manualBookings: {
        id: 'app.manualBookings',
        defaultMessage: 'Manual bookings',
        description: 'Manual Bookings'
    },
    createBooking: {
        id: 'app.createBooking',
        defaultMessage: 'Create booking',
        description: 'Create Booking'
    },
    next: {
        id: 'app.next',
        defaultMessage: 'Next',
        description: 'Next'
    },
    stepOneTitle: {
        id: 'app.stepOneTitle',
        defaultMessage: 'Phone number',
        description: 'Manual booking Title'
    },
    stepTwoTitle: {
        id: 'app.stepTwoTitle',
        defaultMessage: 'Step two',
        description: 'Manual booking Title'
    },
    invalid: {
        id: 'app.invalid',
        defaultMessage: 'Invalid',
        description: 'invalid'
    },
    schedule: {
        id: 'app.schedule',
        defaultMessage: 'Schedule',
        description: 'Label'
    },
    now: {
        id: 'app.now',
        defaultMessage: 'Book now',
        description: 'Label'
    },
    addStop: {
        id: 'app.addStop',
        defaultMessage: 'Add stop',
        description: 'Label'
    },
    noCabs: {
        id: 'app.noCabs',
        defaultMessage: 'No cabs',
        description: 'Label'
    },
    autoAssign: {
        id: 'app.autoAssign',
        defaultMessage: 'Auto assign',
        description: 'Label'
    },
    manageDispatcher: {
        id: 'app.manageDispatcher',
        defaultMessage: 'Manage dispatcher',
        description: 'manageDispatcher'
    },
    fareEstimation: {
        id: 'app.fareEstimation',
        defaultMessage: 'Fare estimation',
        description: 'Label'
    },
    baseFare: {
        id: 'app.baseFare',
        defaultMessage: 'Base fare',
        description: 'Label'
    },
    perMile: {
        id: 'app.perMile',
        defaultMessage: 'Per mile',
        description: 'Label'
    },
    perMinute: {
        id: 'app.perMinute',
        defaultMessage: 'Per minute',
        description: 'Label'
    },
    minutesShort: {
        id: 'app.minutesShort',
        defaultMessage: 'mins',
        description: 'Label'
    },
    bookingFee: {
        id: 'app.bookingFee',
        defaultMessage: 'Booking fee',
        description: 'Label'
    },
    total: {
        id: 'app.total',
        defaultMessage: 'Total',
        description: 'Label'
    },
    travelFare: {
        id: 'app.travelFare',
        defaultMessage: 'Travel fare',
        description: 'Label'
    },
    bookNow: {
        id: 'app.bookNow',
        defaultMessage: 'Book now',
        description: 'Label'
    },
    reset: {
        id: 'app.reset',
        defaultMessage: 'Reset',
        description: 'Label'
    },
    scheduleNow: {
        id: 'app.scheduleNow',
        defaultMessage: 'Schedule now',
        description: 'Label'
    },
    tripScheduledOn: {
        id: 'app.tripScheduledOn',
        defaultMessage: '*Trip scheduled on',
        description: 'Label'
    },
    searchDriverName: {
        id: 'app.searchDriverName',
        defaultMessage: 'Search driver name',
        description: 'Label'
    },
    assign: {
        id: 'app.assign',
        defaultMessage: 'Assign',
        description: 'Label'
    },
    assignDriver: {
        id: 'app.assignDriver',
        defaultMessage: 'Assign driver',
        description: 'Label'
    },
    addOrChange: {
        id: 'app.addOrChange',
        defaultMessage: 'Add or Change',
        description: 'Label'
    },
    cancelBooking: {
        id: 'app.cancelBooking',
        defaultMessage: 'Cancel booking',
        description: 'Label'
    },
    editDateAndTime: {
        id: 'app.editDateAndTime',
        defaultMessage: 'Edit date & time',
        description: 'Label'
    },
    editBooking: {
        id: 'app.editBooking',
        defaultMessage: 'Edit booking',
        description: 'Label'
    },
    cancelScheduleMessage: {
        id: 'app.cancelScheduleMessage',
        defaultMessage: 'Are you sure do you want to cancel the schedule booking?',
        description: 'Label'
    },
    exceedLimit200: {
        id: 'app.exceedLimit200',
        defaultMessage: 'Please dont exceed 200 words',
        description: 'Message'
    },
    perKm: {
        id: 'app.perKm',
        defaultMessage: 'Per Km',
        description: 'Label'
    },
    noDriverFound: {
        id: 'app.noDriverFound',
        defaultMessage: 'No driver found',
        description: 'Label'
    },
    at: {
        id: 'app.at',
        defaultMessage: 'at',
        description: 'Label'
    },
    markerInfo: {
        id: 'app.markerInfo',
        defaultMessage: 'Marker info',
        description: 'Marker Info'
    },
    favIconlogoLabel: {
        id: 'app.favIconlogoLabel',
        defaultMessage: 'Fav icon',
        description: 'Fav Icon'
    },
    contactPhoneNumber: {
        id: 'app.contactPhoneNumber',
        defaultMessage: 'Contact phone number',
        description: 'contactPhoneNumber'
    },
    contactEmail: {
        id: 'app.contactEmail',
        defaultMessage: 'Contact email',
        description: 'contactEmail'
    },
    skype: {
        id: 'app.skype',
        defaultMessage: 'Skype',
        description: 'skype'
    },
    last7Days: {
        id: 'app.last7Days',
        defaultMessage: 'Last 7 days',
        description: 'select label'
    },
    allDays: {
        id: 'app.allDays',
        defaultMessage: 'All days',
        description: 'select label'
    },
    last30Days: {
        id: 'app.last30Days',
        defaultMessage: 'Last 30 days',
        description: 'select label'
    },
    validateInterval: {
        id: 'app.validateInterval',
        defaultMessage: 'Radius must be greater than 50m',
        description: 'validateInterval'
    },
    managePhoneMasking: {
        id: 'app.managePhoneMasking',
        defaultMessage: 'Manage rider phone number visibility',
        description: 'managePhoneMasking'
    },
    numberMasking: {
        id: 'app.numberMasking',
        defaultMessage: 'Phone number masking',
        description: 'numberMasking'
    },
    startRideRadius: {
        id: 'app.startRideRadius',
        defaultMessage: 'Distance restriction for drivers to start a ride',
        description: 'startRideRadius'
    },
    enterRadius: {
        id: 'app.enterRadius',
        defaultMessage: 'Radius',
        description: 'enterRadius'
    },
    validateInterval: {
        id: 'app.validateInterval',
        defaultMessage: 'Radius must be greater than 50m',
        description: 'validateInterval'
    },
    isSurgePrice: {
        id: 'app.isSurgePrice',
        defaultMessage: 'Is surge price?',
        description: 'isSurgePrice'
    },
    pricingType: {
        id: 'app.pricingType',
        defaultMessage: 'Pricing type',
        description: 'pricingType'
    },
    pricingOption1: {
        id: 'app.pricingOption1',
        defaultMessage: 'Date',
        description: 'pricingOption1'
    },
    pricingOption2: {
        id: 'app.pricingOption2',
        defaultMessage: 'Day',
        description: 'pricingOption2'
    },
    dayPricingValue: {
        id: 'app.dayPricingValue',
        defaultMessage: 'Day',
        description: 'day'
    },
    datePricingValue: {
        id: 'app.datePricingValue',
        defaultMessage: 'Date',
        description: 'Date'
    },
    startTime: {
        id: 'app.startTime',
        defaultMessage: 'Start time',
        description: 'startTime'
    },
    endTime: {
        id: 'app.endTime',
        defaultMessage: 'End time',
        description: 'endTime'
    },
    surgeValue: {
        id: 'app.surgeValue',
        defaultMessage: 'Surge value',
        description: 'surgeValue'
    },
    Sunday: {
        id: 'id.Sunday',
        defaultMessage: 'Sunday',
        description: 'Availability days'
    },
    Monday: {
        id: 'id.Monday',
        defaultMessage: 'Monday',
        description: 'Availability days'
    },
    Tuesday: {
        id: 'id.Tuesday',
        defaultMessage: 'Tuesday',
        description: 'Availability days'
    },
    Wednesday: {
        id: 'id.Wednesday',
        defaultMessage: 'Wednesday',
        description: 'Availability days'
    },
    Thursday: {
        id: 'id.Thursday',
        defaultMessage: 'Thursday',
        description: 'Availability days'
    },
    Friday: {
        id: 'id.Friday',
        defaultMessage: 'Friday',
        description: 'Availability days'
    },
    Saturday: {
        id: 'id.Saturday',
        defaultMessage: 'Saturday',
        description: 'Availability days'
    },
    surgePriceDetails: {
        id: 'app.surgePriceDetails',
        defaultMessage: 'Surge price details',
        description: 'surgePriceDetails'
    },
    validateSurge: {
        id: 'app.validateSurge',
        defaultMessage: 'Must be greater than 0.5',
        description: 'validateSurge'
    },
    tripTone: {
        id: 'app.tripTone',
        defaultMessage: 'Trip accept timer tone',
        description: 'tripTone'
    },
    uploadTripTone: {
        id: 'app.uploadTripTone',
        defaultMessage: 'Upload timer tone',
        description: 'uploadTripTone'
    },
    appOpenTrip: {
        id: 'app.appOpenTrip',
        defaultMessage: 'Open the driver app when a trip notification is received',
        description: 'appOpenTrip'
    },
    valueContent: {
        id: 'app.valueContent',
        defaultMessage: 'Value',
        description: 'valueContent'
    },
    firstnameValidate: {
        id: 'app.firstnameValidate',
        defaultMessage: 'First name must be within 3 to 20 characters',
        description: 'firstnameValidate'
    },
    lastnameValidate: {
        id: 'app.lastnameValidate',
        defaultMessage: 'Last name must be within 3 to 20 characters',
        description: 'lastnameValidate'
    },
    gender: {
        id: 'app.gender',
        defaultMessage: 'Gender',
        description: 'gender'
    },
    male: {
        id: 'app.male',
        defaultMessage: 'Male',
        description: 'male'
    },
    female: {
        id: 'app.female',
        defaultMessage: 'Female',
        description: 'female'
    },
    otherGender: {
        id: 'app.otherGender',
        defaultMessage: 'Others',
        description: 'otherGender'
    },
    vehicleColor: {
        id: 'app.vehicleColor',
        defaultMessage: 'Vehicle color',
        description: 'vehicleColor'
    },
    vehicleAvailability: {
        id: 'app.vehicleAvailability',
        defaultMessage: 'Vehicle availability',
        description: 'vehicleAvailability'
    },
    childSeatAvailability: {
        id: 'app.childSeatAvailability',
        defaultMessage: 'Child seat availability',
        description: 'childSeatAvailability'
    },
    wheelChairAvailability: {
        id: 'app.wheelChairAvailability',
        defaultMessage: 'Wheel chair availability',
        description: 'wheelChairAvailability'
    },
    privacyType: {
        id: 'app.privacyType',
        defaultMessage: 'Is available for anyone?',
        description: 'privacyType'
    },
    public: {
        id: 'app.public',
        defaultMessage: 'Public',
        description: 'public'
    },
    private: {
        id: 'app.private',
        defaultMessage: 'Private',
        description: 'private'
    },
    rideComfortOptions: {
        id: 'app.rideComfortOptions',
        defaultMessage: 'Ride comfort options',
        description: 'rideComfortOptions'
    },
    womenDrivers: {
        id: 'app.womenDrivers',
        defaultMessage: 'Women only drivers',
        description: 'Women only drivers'
    },
    legalStaticPage: {
        id: 'app.legalStaticPage',
        defaultMessage: 'Legal',
        description: 'Manage static page'
    },
    aboutImage3: {
        id: 'app.aboutImage3',
        defaultMessage: 'Feature icon #2',
        description: 'Feature Banner 3'
    },
    aboutImage4: {
        id: 'app.aboutImage4',
        defaultMessage: 'Feature icon #3',
        description: 'Feature icon #3'
    },
    configSettings: {
        id: 'app.configSettings',
        defaultMessage: 'Manage site configurations',
        description: 'Manage site configurations'
    },
    stripeSecretKey: {
        id: 'app.stripeSecretKey',
        defaultMessage: 'Stripe secret key',
        description: 'Stripe secret key'
    },
    twillioAccountSid: {
        id: 'app.twillioAccountSid',
        defaultMessage: 'Twilio account SID',
        description: 'twillioAccountSid',
    },
    twillioAuthToken: {
        id: 'app.twillioAuthToken',
        defaultMessage: 'Twilio auth token',
        description: 'twillioAuthToken',
    },
    twillioPhone: {
        id: 'app.twillioPhone',
        defaultMessage: 'Twilio phone number',
        description: 'twillioPhone',
    },
    twilio: {
        id: 'app.twilio',
        defaultMessage: 'Twilio settings',
        description: 'twilio',
    },
    maxUploadLabel: {
        id: 'app.maxUploadLabel',
        defaultMessage: 'Maximum image upload size [MB/KB]',
        description: 'maxUploadLabel',
    },
    pushNotificationKey: {
        id: 'app.pushNotificationKey',
        defaultMessage: 'Push notification key',
        description: 'pushNotificationKey',
    },
    otherSettings: {
        id: 'app.otherSettings',
        defaultMessage: 'Other settings',
        description: 'otherSettings',
    },
    allowableDistaceTitle: {
        id: 'app.allowableDistaceTitle',
        defaultMessage: 'Maximum distance to cover while fetching drivers',
        description: 'allowableDistaceTitle'
    },
    samePlaceValidate: {
        id: 'app.samePlaceValidate',
        defaultMessage: 'Pickup and drop location should not be same',
        description: 'samePlaceValidate',
    },
    lightMode: {
        id: 'app.lightMode',
        defaultMessage: 'Light mode',
        description: 'Light mode',
    },
    darkMode: {
        id: 'app.darkMode',
        defaultMessage: 'Dark mode',
        description: 'Dark mode',
    },
    maxWaitingTime: {
        id: 'app.othermaxWaitingTimeSettings',
        defaultMessage: 'Maximum waiting time',
        description: 'maxWaitingTime',
    },
    waitingPrice: {
        id: 'app.waitingPrice',
        defaultMessage: 'Waiting fare',
        description: 'waitingPrice',
    },
    proceed: {
        id: 'app.proceed',
        defaultMessage: 'Proceed',
        description: 'proceed',
    },
    managePaymentGateWay: {
        id: 'app.managePaymentGateWay',
        defaultMessage: 'Manage payment methods',
        description: 'Manage Payment Gateway',
    },
    paymentGateWay: {
        id: 'app.paymentGateWay',
        defaultMessage: 'Payment gateway',
        description: 'Payment Gateway',
    },
    canceledByRider: {
        id: 'app.canceledByRider',
        defaultMessage: 'Cancel by rider',
        description: 'Cancel by rider',
    },
    canceledByDriver: {
        id: 'app.canceledByDriver',
        defaultMessage: 'Cancel by driver',
        description: 'Cancel by driver',
    },
    otherResons: {
        id: 'app.otherResons',
        defaultMessage: 'Other reasons',
        description: 'Other reasons',
    },
    notificationInterval: {
        id: 'app.notificationInterval',
        defaultMessage: 'Trip acceptance time for the driver',
        description: 'notificationInterval',
    },
    validateIntervalTime: {
        id: 'app.validateIntervalTime',
        defaultMessage: 'Notification interval must be greater than 0.5 min',
        description: 'validateIntervalTime'
    },
    refreshText: {
        id: 'app.refreshText',
        defaultMessage: 'Refresh',
        description: 'refreshText'
    },
    cancelRiderReason: {
        id: 'app.cancelRiderReason',
        defaultMessage: 'You can cancel the trip on behalf of the rider by using the following reasons',
        description: 'cancelRiderReason'
    },
    cancelDriverReason: {
        id: 'app.cancelDriverReason',
        defaultMessage: 'You can cancel the trip on behalf of the driver by using the following reasons',
        description: 'cancelDriverReason'
    },
    endTimeValidateMessage: {
        id: 'app.endTimeValidateMessage',
        defaultMessage: "End time must be higher than start time.",
        description: 'End time must be higher than start time.',
    },
    paystackSettings: {
        id: 'app.paystackSettings',
        defaultMessage: 'Paystack settings',
        description: 'paystackSettings'
    },
    paystackSecretKey: {
        id: 'app.paystackSecretKey',
        defaultMessage: 'Paystack secret key',
        description: 'Paystack secret key'
    },
    paystack: {
        id: 'app.paystack',
        defaultMessage: 'Paystack',
        description: 'Paystack'
    },
    fcmPushNotificationKey: {
        id: 'app.fcmPushNotificationKey',
        defaultMessage: 'FCM push notification key',
        description: 'fcmPushNotificationKey',
    },
    fcmPushNotificationSettings: {
        id: 'app.fcmPushNotificationSettings',
        defaultMessage: 'Push Notification Settings',
        description: 'fcmPushNotificationSettings'
    },
    chooseCountry: {
        id: 'app.chooseCountry',
        defaultMessage: 'Choose Country',
        description: 'Paystack',
    },
    chooseCurrency: {
        id: 'app.chooseCurrency',
        defaultMessage: 'Choose Currency',
        description: 'Paystack',
    },
    paystackCountry: {
        id: 'app.paystackCountry',
        defaultMessage: 'Paystack country',
        description: 'Paystack',
    },
    paystackCurrency: {
        id: 'app.paystackCurrency',
        defaultMessage: 'Paystack currency',
        description: 'Paystack',
    },
    southafrica: {
        id: 'app.southafrica',
        defaultMessage: 'South Africa',
        description: 'Paystack'
    },
    nigeria: {
        id: 'app.nigeria',
        defaultMessage: 'Nigeria',
        description: 'Paystack'
    },

    ghana: {
        id: 'app.ghana',
        defaultMessage: 'Ghana',
        description: 'Paystack'
    },
    zar: {
        id: 'app.zar',
        defaultMessage: 'ZAR',
        description: 'Southafrica currency'
    },
    ngn: {
        id: 'app.ngn',
        defaultMessage: 'NGN',
        description: 'Nigeria currency'
    },
    ghs: {
        id: 'app.ghs',
        defaultMessage: 'GHS',
        description: 'Ghana currency'
    },
    meter: {
        id: 'app.meter',
        defaultMessage: 'meter',
        description: 'meter'

    },
    stripePublishKeyTooltip: {
        id: 'app.stripePublishKeyTooltip',
        defaultMessage: 'This field decides the mode of payment(Live payment or Test payment)',
        description: 'Tooltip'
    },
    stripeSecrectKeyTooltip: {
        id: 'app.stripeSecrectKeyTooltip',
        defaultMessage: 'It\'s used to authenticate the application to the Stripe server when making API calls',
        description: 'Tooltip'
    },
    twilioAccountTooltip: {
        id: 'app.twilioAccountTooltip',
        defaultMessage: 'It\'s an unique identifier for your Twilio account',
        description: 'Tooltip'
    },
    twilioAuthTooltip: {
        id: 'app.twilioAuthTooltip',
        defaultMessage: 'It\'s a kind of secret key for your account. And it\'s helps to identify the account is authorized or not',
        description: 'Tooltip'
    },
    twilioPhonenumberTooltip: {
        id: 'app.twilioPhonenumberTooltip',
        defaultMessage: 'It\'s a phone number purchased through Twilio account and it helps to send messages or make phone calls using Twilio.',
        description: 'Tooltip'
    },
    maxDistanceTooltip: {
        id: 'app.maxDistanceTooltip',
        defaultMessage: 'It helps to fetch the drivers within the given distance. And it determines the range that the trip request needs to be triggered.',
        description: 'Tooltip'
    },
    fcmKeyTooltip: {
        id: 'app.fcmKeyTooltip',
        defaultMessage: 'It helps you to send push notifications.',
        description: 'Tooltip'
    },
    forceUpdateTooltip: {
        id: 'app.forceUpdateTooltip',
        defaultMessage: 'This field allows the admin to control the application update status by selecting options within this dropdown field.',
        description: 'Tooltip'
    },
    androidRiderTooltip: {
        id: 'app.androidRiderTooltip',
        defaultMessage: 'This field allows the admin to enter the Android version of the rider application',
        description: 'Tooltip'
    },
    iosTooRiderltip: {
        id: 'app.iosTooRiderltip',
        defaultMessage: 'This field allows the admin to enter the iOS version of the rider application',
        description: 'Tooltip'
    },
    androidDriverTooltip: {
        id: 'app.androidDriverTooltip',
        defaultMessage: 'This field allows the admin to enter the Andriod version of the driver application',
        description: 'Tooltip'
    },
    iosDriverTooltip: {
        id: 'app.iosDriverTooltip',
        defaultMessage: 'This field allows the admin to enter the iOS version of the driver application',
        description: 'Tooltip'
    },
    stopSettingTooltip: {
        id: 'app.stopSettingTooltip',
        defaultMessage: 'It helps you to choose waiting time for the multiple stops feature',
        description: 'Tooltip'
    },
    distanceTypeTooltip: {
        id: 'app.distanceTypeTooltip',
        defaultMessage: 'This field allows the admin to select their preferred distance type [Km/Miles]',
        description: 'Tooltip'
    },
    distanceTooltip: {
        id: 'app.distanceTooltip',
        defaultMessage: 'This field allows the admin to show or hide the distance value on the driver\'s trip request window.',
        description: 'Tooltip'
    },
    durationTooltip: {
        id: 'app.durationTooltip',
        defaultMessage: 'This field allows the admin to show or hide the duration value on the driver\'s trip request window.',
        description: 'Tooltip'
    },
    pickupTooltip: {
        id: 'app.pickupTooltip',
        defaultMessage: 'This field allows the admin to show or hide the pickup location on the driver\'s trip request window.',
        description: 'Tooltip'
    },
    dropTooltip: {
        id: 'app.dropTooltip',
        defaultMessage: 'This field allows the admin to show or hide the drop location on the driver\'s trip request window.',
        description: 'Tooltip'
    },
    estimatePriceTooltip: {
        id: 'app.estimatePriceTooltip',
        defaultMessage: 'This field allows the admin to show or hide the estimated price on the driver\'s trip request window.',
        description: 'Tooltip'
    },
    tripNotificationTooltip: {
        id: 'app.tripNotificationTooltip',
        defaultMessage: 'This option allows the admin to control whether the driver app will automatically open when a trip notification is received. [Only on Android app]',
        description: 'Tooltip'
    },
    tripAcceptTimerTooltip: {
        id: 'app.tripAcceptTimerTooltip',
        defaultMessage: 'This option allows the admin to manage the sound notification for the trip request window by uploading an audio file into this field.',
        description: 'Tooltip'
    },
    uploadTimerTooltip: {
        id: 'app.uploadTimerTooltip',
        defaultMessage: 'This field will help the admin to upload the trip timer tone for the driver application',
        description: 'Tooltip'
    },
    iosDriverSleepTooltip: {
        id: 'app.iosDriverSleepTooltip',
        defaultMessage: 'It is used to choose whether the driver app should remain open on the mobile device until the user decides to close it.',
        description: 'Tooltip'
    },
    androidDriverSleepTooltip: {
        id: 'app.androidDriverSleepTooltip',
        defaultMessage: 'It is used to choose whether the driver app should remain open on the mobile device until the user decides to close it.',
        description: 'Tooltip'
    },
    radiusTooltip: {
        id: 'app.radiusTooltip',
        defaultMessage: 'This field will allow the admin to specify how close the driver must be to the rider before they can start a ride',
        description: 'Tooltip'
    },
    maxWaitingTooltip: {
        id: 'app.maxWaitingTooltip',
        defaultMessage: 'This field specifies how long the driver should wait at the rider\'s place. If the wait surpasses this time, they earn a waiting fare for each additional minute.',
        description: 'Tooltip'
    },
    tripAcceptTimeDriverTooltip: {
        id: 'app.tripAcceptTimeDriverTooltip',
        defaultMessage: 'This field allows the admin to adjust the trip request time by entering the desired number of minutes into this specific field',
        description: 'Tooltip'
    },
    contactPhoneTooltip: {
        id: 'app.contactPhoneTooltip',
        defaultMessage: 'It indicates the platform contact phone number',
        description: 'Tooltip'
    },
    contactEmailTooltip: {
        id: 'app.contactEmailTooltip',
        defaultMessage: 'It indicates the platform contact email',
        description: 'Tooltip'
    },
    skypeTooltip: {
        id: 'app.skypeTooltip',
        defaultMessage: 'It indicates the platform Skype ID',
        description: 'Tooltip'
    },
    payStackCountryTooltip: {
        id: 'app.payStackCountryTooltip',
        defaultMessage: 'Please select the country where you want to allow this payment method',
        description: 'Tooltip'
    },
    paystackCurrencyTooltip: {
        id: 'app.paystackCurrencyTooltip',
        defaultMessage: 'Please choose the currency corresponding to your country.',
        description: 'Tooltip'
    },
    paystackSecretKeyTooltip: {
        id: 'app.paystackSecretKeyTooltip',
        defaultMessage: 'Enter your Paystack key here to link your Paystack account with the platform',
        description: 'Tooltip'
    },
    updateStatus:{
        id:'app.updateTripStatus',
        defaultMessage:'Update trip status',
        description:'updateTripStatus'
    },
    completeTrip:{
        id: 'app.completeTrip',
        defaultMessage:'Complete trip',
        description: 'completeTrip'
    },
    descriptionComplete:{
        id:'app.descriptionComplete',
        defaultMessage:'Are you sure to change the status of this trip to completed?',
        description:'descriptionComplete'
    },
    fareTimeError:{
        id: 'app.fareTimeError',
        defaultMessage: 'Some rate increases were deactivated, row:',
        description:'fareTimeError'
    },
    vehicleUser:{
        id:"app.vehicleUser",
        defaultMessage: "Vehicle(s)",
        description:"Vehicle(s)"
    },
    licenceMissing:{
        id: "app.licenceMissing",
        defaultMessage: "The driver has not completed the registration process",
        description:"licenceMissing"
    },
    vehiclesInfo:{
        id:"app.vehiclesInfo",
        defaultMessage: "Vehicle(s) information",
        description: "vehiclesInfo"
    },
    verified:{
        id:"app.verified",
        defaultMessage: "Verified",
        description: "Verified"
    },
    seeDetails:{
        id: "app.seeDetails",
        defaultMessage: "See Details",
        description: "seeDetails"
        
    }
});

export default messages;
